export const HOW_TO_USE_ANNOTATIONS_OPTIONS = [
  'Use SHIFT to start an annotation',
  'Double-Click to end a selection when using Polygon',
  'If Draw Mode is enabled, SHIFT is not required to start an annotation',
  'Use the Show/Hide Menu to hide or show annotations',
];

export const HOW_TO_USE_MEASUREMENT_OPTIONS = [
  'Click a point to start a measurement',
  'Click a point to end the measurement.',
  'To cancel a measurement while in progress, press Z',
  'Click on the measurement tool to hide or show measurements',
];
